/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import Select from "react-select";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import {
  AvForm,
  AvField,
  AvGroup,
  AvFeedback,
  AvInput,
} from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// //Import customDatePicker
// import CustomDatePicker2 from "../../components/Common/CustomDatePicker2";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

//Import Custom ExtraFields Component
import ExtraFields from "./ExtraFields";

//Lodash
import { isEqual } from "lodash";

import {
  getCompanies,
  getUser,
  createUser,
  editUser,
  resetUser,
  resetUsers,
  resetError,
  resetUserPassword,
} from "../../store/actions";

import "./users.scss";

const NewUser = ({ t }) => {
  let { idCompany, idUser } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const { dataCompany } = useSelector((state) => state.Company);
  const {
    dataUserGetSet,
    dataUserEditCreate,
    loadingUser,
    loadingUserEditCreate,
    successUser,
    errorUser,
    resetPasswordResponseMessage,
    resetPasswordUserLoading,
  } = useSelector((state) => state.User);

  const minMaxChat = 0;
  const maxMaxChat = 20;
  const activeDefault = true;

  const [userValues, setUserValues] = useState({
    name: "",
    email: "",
    active: activeDefault,
    nickname: "",
    url_avatar: null,
    max_chats: null,
    profiles: [],
    profilesBk: [],
    skills: [],
    skillsBk: [],
    groups: [],
    groupsBk: [],
    departments: [],
    departmentsBk: [],
    isAutomationOnly: false
  });

  const [companyName, setCompanyName] = useState("");

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [departmentId, setDepartmentId] = useState();
  const [optProfile, setOptProfile] = useState({ options: [] });
  const [optSkill, setOptSkill] = useState({ options: [] });
  const [optGroup, setOptGroup] = useState({ options: [] });
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isVisiblePassword, setIsVisiblePassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);

  const handleChangePassword = (e) => {
    e.preventDefault();
    if (newPassword === confirmNewPassword) {
      if (newPassword.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,30}$/)) {
        dispatch(
          resetUserPassword(newPassword, confirmNewPassword, idUser, idCompany)
        );
      } else {
        showToast(
          "error",
          t(
            "Your passowrd must be composed with minimum eight characters, maximum thirty characters, at least one uppercase letter, one lowercase letter and one number"
          )
        );
      }
    } else {
      showToast("error", t("Passwords do not match"));
    }
  };

  const handleCreateEditUser = () => {
    if (idCompany) {
      if (idUser) {
        dispatch(editUser(idUser, newFields, idCompany));
      } else {
        dispatch(createUser(newFields, idCompany));
      }
    }
  };
  function getRandomSpecialCharacter() {
    const specialChars = "!@#$%^&*()_+-=[]{};':\"\\|,.<>/?";
    return specialChars.charAt(Math.floor(Math.random() * specialChars.length));
  }
  const handleGeneratePassword = () => {
    const randomPass = Math.random().toString(36).substr(2, 8);
    const randomCapitalLetter = String.fromCharCode(
      65 + Math.floor(Math.random() * 26)
    );
    const randomSpecialChar = getRandomSpecialCharacter();

    const randomNumber = Math.floor(Math.random() * 10);

    setNewPassword(randomPass + randomCapitalLetter + randomSpecialChar+randomNumber);
    setConfirmNewPassword(randomPass + randomCapitalLetter + randomSpecialChar+randomNumber);
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successUser &&
      dispatch(resetUser()) &&
      dispatch(resetUsers()) &&
      history.push("/users"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dispatch(getCompanies(1, 100));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataCompany?.clients) {
      setCompanyName(
        dataCompany.clients.find((company) => company.id === idCompany)?.name
      );
    }
  }, [dataCompany]);

  useEffect(() => {
    if (idUser && idCompany) {
      dispatch(getUser(idUser, idCompany, true));
    } else {
      dispatch(getUser(null, idCompany, true));
      setNewFields((previous) => ({
        ...previous,
        active: activeDefault,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idUser]);

  useEffect(() => {
    if (
      idUser &&
      dataUserGetSet &&
      dataUserGetSet.data &&
      dataUserGetSet.data.user
    ) {
      setDepartmentId(dataUserGetSet.data.user.department_id);
      let departmentsToPrint = [];
      let profilesToPrint = [];
      let skillsToPrint = [];
      let groupsToPrint = [];

      if (dataUserGetSet.data.user.profiles) {
        profilesToPrint = dataUserGetSet.data.user.profiles.map(
          (profile, key) => ({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      }
      if (dataUserGetSet.data.user.skills) {
        skillsToPrint = dataUserGetSet.data.user.skills.map((skill, key) => ({
          key: key,
          value: skill.id,
          label: skill.name,
        }));
      }
      if (dataUserGetSet.data.user.groups) {
        groupsToPrint = dataUserGetSet.data.user.groups.map((group, key) => ({
          key: key,
          value: group.id,
          label: group.name,
        }));
      }
      if (dataUserGetSet.data.user.departments) {
        departmentsToPrint = dataUserGetSet.data.user.departments.map(
          (department, key) => ({
            key: key,
            value: department.id,
            label: department.name,
          })
        );
      }

      setUserValues((previous) => ({
        ...previous,
        name: dataUserGetSet.data.user.name,
        email: dataUserGetSet.data.user.email,
        nickname: dataUserGetSet.data.user.nickname,
        max_chats: dataUserGetSet.data.user.max_chats,
        departments: departmentsToPrint[0].value,
        profiles: profilesToPrint[0].value,
        skills: skillsToPrint,
        groups: groupsToPrint,
        departmentsBk: departmentsToPrint.map((item) => item.value),
        profilesBk: profilesToPrint.map((item) => item.value),
        skillsBk: skillsToPrint.map((item) => item.value),
        groupsBk: groupsToPrint.map((item) => item.value),
        extraBk: dataUserGetSet.data.user.extra,
        isAutomationOnly: dataUserGetSet.data.user.is_automation_only,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUserGetSet]);

  useEffect(() => {
    if (resetPasswordResponseMessage) {
      showToast("success", t(resetPasswordResponseMessage.message));
    }
  }, [resetPasswordResponseMessage]);

  useEffect(() => {
    if (dataUserEditCreate && dataUserEditCreate.message) {
      showToast("success", t(dataUserEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successUser]);

  useEffect(() => {
    if (errorUser && typeof errorUser === "object") {
      errorUser.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorUser) {
        showToast("error", t(errorUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorUser]);

  const optionsDepartment = () => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        dataUserGetSet &&
        dataUserGetSet.data &&
        dataUserGetSet.data.form &&
        dataUserGetSet.data.form.departments &&
        dataUserGetSet.data.form.departments.length > 0
      ) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataUserGetSet.data.form.departments.map((department, key) =>
          options.push({
            key: key,
            value: department.id,
            label: department.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const optionsProfile = (objDepartment) => {
    let options = [];
    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      options.push({
        value: "",
        label: t("Select"),
        isDisabled: true,
      });
      if (
        objDepartment &&
        objDepartment.profiles &&
        objDepartment.profiles.length > 0
      ) {
        objDepartment.profiles.map((profile, key) =>
          options.push({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      } else {
        if (objDepartment && options.length > 0) options.pop();
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptProfile({ options: options });
  };

  const optionsSkill = (objDepartment) => {
    let options = [];

    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        objDepartment &&
        objDepartment.skills &&
        objDepartment.skills.length > 0
      ) {
        objDepartment.skills.map((skill, key) =>
          options.push({
            key: key,
            value: skill.id,
            label: skill.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptSkill({ options: options });
  };

  const optionsGroup = (objDepartment) => {
    let options = [];
    if (loadingUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        objDepartment &&
        objDepartment.groups &&
        objDepartment.groups.length > 0
      ) {
        objDepartment.groups.map((group, key) =>
          options.push({
            key: key,
            value: group.id,
            label: group.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    setOptGroup({ options: options });

    return options;
  };

  useEffect(() => {
    let objDepartment =
      dataUserGetSet &&
      dataUserGetSet.data &&
      dataUserGetSet.data.form &&
      dataUserGetSet.data.form.departments &&
      dataUserGetSet.data.form.departments.find(
        (department) => department.id === departmentId
      );
    optionsProfile(objDepartment);
    optionsSkill(objDepartment);
    optionsGroup(objDepartment);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentId]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/users"
            path={idUser ? "/user/" + idUser : "/user"}
            title={t("Users")}
            breadcrumbItem={!idUser ? t("Create user") : t("Edit User")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Label className="font-size-16 text-dark">
                    {companyName}
                  </Label>
                  <div className="feature-card mb-2 p-3">
                    <AvForm onValidSubmit={handleCreateEditUser}>
                      <Row>
                        <Col sm="6">
                          <FormGroup>
                            <AvField
                              label={t("Name") + " *"}
                              id="name"
                              name="name"
                              type="text"
                              className="form-control"
                              placeholder={t("User name")}
                              onChange={(e) => {
                                if (e.target.value === userValues.name) {
                                  delete newFields.name;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    name: e.target.value,
                                  }));
                                }
                              }}
                              value={userValues.name}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage: t("Invalid field"),
                                },
                                pattern: {
                                  value: "/^[A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                  errorMessage: t(
                                    "Your name must be composed only with letter and space"
                                  ),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              label={t("Email") + " *"}
                              id="registration-email"
                              name="registrationemail"
                              type="email"
                              className="form-control"
                              placeholder={t("example@example.com")}
                              onChange={(e) => {
                                if (e.target.value === userValues.email) {
                                  delete newFields.email;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    email: e.target.value,
                                  }));
                                }
                              }}
                              value={userValues.email}
                              validate={{
                                email: {
                                  value: true,
                                  errorMessage: t("Incorrect email"),
                                },
                                maxLength: {
                                  value: 100,
                                  errorMessage: t("Invalid field"),
                                },
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <AvField
                              label={t("Nickname") + " *"}
                              id="nickname"
                              name="nickname"
                              type="text"
                              className="form-control"
                              placeholder={t("User nickname")}
                              onChange={(e) => {
                                if (e.target.value === userValues.nickname) {
                                  delete newFields.nickname;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    nickname: e.target.value,
                                  }));
                                }
                              }}
                              value={userValues.nickname}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                minLength: {
                                  value: 3,
                                  errorMessage: t("Invalid field"),
                                },
                                maxLength: {
                                  //Maximum value changed
                                  value: 255,
                                  errorMessage: t("Invalid field"),
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <AvField
                              id="max-chats"
                              name="max-chats"
                              className="form-control"
                              type="number"
                              label={t("Max Chat") + " *"}
                              placeholder={t("Enter maximum chats")}
                              onChange={(e) => {
                                if (e.target.value === userValues.max_chats) {
                                  delete newFields.max_chats;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    max_chats: e.target.value,
                                  }));
                                }
                              }}
                              value={userValues.max_chats}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                                min: {
                                  value: minMaxChat,
                                  errorMessage: `${t("Minimum")} ${minMaxChat}`,
                                },
                                max: {
                                  value: maxMaxChat,
                                  errorMessage: `${t("Maximum")} ${maxMaxChat}`,
                                },
                              }}
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label>{t("Access only via API (automation user)")}</Label>
                            <div
                              className="custom-control custom-switch"
                              dir="ltr"
                            >
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="automation-only"
                                onChange={(e) => {
                                  const newValue = !!e.target.checked
                                  setNewFields((previous) => ({
                                    ...previous,
                                    is_automation_only: newValue
                                  }))
                                  setUserValues((previous) => ({
                                    ...previous,
                                    isAutomationOnly: newValue
                                  }));
                                }}
                                checked={userValues.isAutomationOnly || false}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="automation-only"
                              >
                                {userValues.isAutomationOnly ? t("Active") : t("Inactive")}
                              </label>
                            </div>
                          </FormGroup>
                          {dataUserGetSet?.data?.form?.extra?.length > 0 && (
                            <FormGroup className="form-box">
                              <Label>{t("Extra")}</Label>
                              <ExtraFields
                                fields={dataUserGetSet?.data?.form?.extra}
                                onChange={(e) => {
                                  if (isEqual(e, userValues.extra)) {
                                    delete newFields.extra;
                                    checkSubmit();
                                  } else {
                                    setNewFields((previous) => ({
                                      ...previous,
                                      extra: e,
                                    }));
                                  }
                                }}
                                value={userValues.extraBk}
                              />
                            </FormGroup>
                          )}
                          {/* TODO: Descomentar se api estiver pronta
                        <FormGroup>
                          <Label id="skill-work-days">{t("Work days")}</Label>
                          <CustomDatePicker2
                            type="day"
                            //TODO: Habilitar campo quando API estiver pronta
                            //values={userValues.schedules}
                            // onChange={(e) =>
                            //   handleSchedule(e, userValues.schedulesBk)
                            // }
                            disabled
                          />
                        </FormGroup> */}
                        </Col>

                        <Col sm="6">
                          <FormGroup className="select2-container">
                            <AvField
                              id="department"
                              name="department"
                              className="form-control"
                              type="select"
                              label={t("Department") + " *"}
                              onChange={(e) => {
                                let departmentId = e.target.value;
                                setDepartmentId(departmentId);
                                if (
                                  departmentId === userValues.departmentsBk[0]
                                ) {
                                  delete newFields.department_id;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    department_id: departmentId,
                                    profile_id: [],
                                    skill_id: [],
                                    group_id: [],
                                  }));
                                  setUserValues((previous) => ({
                                    ...previous,
                                    profiles: [],
                                    skills: [],
                                    groups: [],
                                  }));
                                }
                              }}
                              value={userValues.departments}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                            >
                              {optionsDepartment().map((department, key) => (
                                <option
                                  key={key}
                                  value={department.value}
                                  disabled={department.isDisabled}
                                >
                                  {department.label}
                                </option>
                              ))}
                            </AvField>
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <AvField
                              name="profile"
                              className="form-control"
                              type="select"
                              label={t("Profile") + " *"}
                              onChange={(e) => {
                                let profileId = e.target.value;
                                if (profileId === userValues.profilesBk[0]) {
                                  delete newFields.profile_id;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    profile_id: profileId,
                                  }));
                                }
                                setUserValues({
                                  ...userValues,
                                  profiles: profileId,
                                });
                              }}
                              value={userValues.profiles}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                              disabled={!departmentId ? true : false}
                            >
                              {optProfile.options.map((profile, key) => (
                                <option
                                  key={key}
                                  value={profile.value}
                                  disabled={profile.isDisabled}
                                >
                                  {profile.label}
                                </option>
                              ))}
                            </AvField>
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <Label className="control-label">
                              {t("Skills")}
                            </Label>
                            <Select
                              classNamePrefix="select2-selection"
                              placeholder={t("Select") + "..."}
                              title={t("Skills")}
                              options={optSkill.options}
                              onChange={(e) => {
                                if (
                                  e &&
                                  JSON.stringify(
                                    e.map((item) => item.value)
                                  ) === JSON.stringify(userValues.skillsBk)
                                ) {
                                  delete newFields.skill_id;
                                  checkSubmit();
                                } else {
                                  setNewFields({
                                    ...newFields,
                                    skill_id: e
                                      ? e.map((item) => item.value)
                                      : [],
                                  });
                                }
                                setUserValues({
                                  ...userValues,
                                  skills: e ? e : [],
                                });
                              }}
                              value={userValues.skills}
                              isDisabled={!departmentId ? true : false}
                              isMulti
                            />
                          </FormGroup>
                          <FormGroup className="select2-container">
                            <Label className="control-label">
                              {t("Group")}
                            </Label>
                            <Select
                              classNamePrefix="select2-selection"
                              placeholder={t("Select") + "..."}
                              title={t("Group")}
                              options={optGroup.options}
                              onChange={(e) => {
                                if (
                                  e &&
                                  JSON.stringify(
                                    e.map((item) => item.value)
                                  ) === JSON.stringify(userValues.groupsBk)
                                ) {
                                  delete newFields.group_id;
                                  checkSubmit();
                                } else {
                                  setNewFields({
                                    ...newFields,
                                    group_id: e
                                      ? e.map((item) => item.value)
                                      : [],
                                  });
                                }
                                setUserValues({
                                  ...userValues,
                                  groups: e ? e : [],
                                });
                              }}
                              value={userValues.groups}
                              isDisabled={!departmentId ? true : false}
                              isMulti
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Button
                        type="submit"
                        color="primary"
                        className="mr-1 waves-effect waves-light"
                        style={{
                          minWidth: "100px",
                          cursor: enableSubmit ? "pointer" : "no-drop",
                        }}
                        disabled={!enableSubmit}
                      >
                        {loadingUserEditCreate ? (
                          <Spinner
                            size="sm"
                            animation="border"
                            style={{
                              height: "19px",
                              width: "19px",
                            }}
                          />
                        ) : (
                          t("Confirm")
                        )}
                      </Button>
                      <Link to="/users">
                        {" "}
                        <Button
                          type="button"
                          color="secondary"
                          className="waves-effect"
                          onClick={() => dispatch(resetUser())}
                        >
                          {t("Cancel")}
                        </Button>
                      </Link>
                    </AvForm>
                  </div>

                  {idUser && (
                    <>
                      <Label className="font-size-16 text-dark">
                        {t("Update password")}
                      </Label>
                      <div className="feature-card mb-2 reset-password-form p-3">
                        <AvForm onValidSubmit={handleChangePassword}>
                          <AvGroup>
                            <Label for="password">{t("New password")}</Label>
                            <InputGroup>
                              <AvInput
                                name="password"
                                type={isVisiblePassword ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder={t("New password")}
                                required
                                validate={{
                                  pattern: {
                                    value:
                                    /^(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_]).{8,}$/,
                                    errorMessage: t(
                                      "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                    ),
                                  },
                                }}
                              />
                              <InputGroupAddon addonType="append">
                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#2e3548",
                                    color: "#bfc8e2",
                                    outline: "none",
                                    border: "1px solid #32394e",
                                    borderRadius: "0 0.25em 0.25em 0",
                                    width: "3em",
                                    marginLeft: "1px",
                                  }}
                                  onClick={() =>
                                    setIsVisiblePassword(!isVisiblePassword)
                                  }
                                >
                                  {isVisiblePassword ? (
                                    <i className="bx bx-hide"></i>
                                  ) : (
                                    <i className="bx bx-show"></i>
                                  )}
                                </button>
                              </InputGroupAddon>
                              <AvFeedback>
                                {t(
                                  "Password must be at least 8 characters long, contain at least one uppercase character, contain at least one number and contain at least one special character"
                                )}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>

                          <AvGroup>
                            <Label for="passwordConfirm">
                              {t("Confirm new password")}
                            </Label>
                            <InputGroup>
                              <AvInput
                                name="passwordConfirm"
                                type={
                                  isVisibleConfirmPassword ? "text" : "password"
                                }
                                value={confirmNewPassword}
                                onChange={(e) =>
                                  setConfirmNewPassword(e.target.value)
                                }
                                placeholder={t("Confirm new password")}
                                required
                                validate={{
                                  match: {
                                    value: "password",
                                    errorMessage: t(
                                      "Passwords do not match, try again."
                                    ),
                                  },
                                }}
                              />
                              <InputGroupAddon addonType="append">
                                <button
                                  type="button"
                                  style={{
                                    backgroundColor: "#2e3548",
                                    color: "#bfc8e2",
                                    outline: "none",
                                    border: "1px solid #32394e",
                                    borderRadius: "0 0.25em 0.25em 0",
                                    width: "3em",
                                    marginLeft: "1px",
                                  }}
                                  onClick={() =>
                                    setIsVisibleConfirmPassword(
                                      !isVisibleConfirmPassword
                                    )
                                  }
                                >
                                  {isVisibleConfirmPassword ? (
                                    <i className="bx bx-hide"></i>
                                  ) : (
                                    <i className="bx bx-show"></i>
                                  )}
                                </button>
                              </InputGroupAddon>
                              <AvFeedback>
                                {t("Passwords do not match, try again.")}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>

                          <div>
                            <Button
                              color="primary"
                              className="waves-effect update-password-button"
                            >
                              {resetPasswordUserLoading ? (
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    height: "19px",
                                    width: "19px",
                                  }}
                                />
                              ) : (
                                t("Update password")
                              )}
                            </Button>
                            <Button
                              color="secondary"
                              className="waves-effect update-password-button"
                              type="button"
                              onClick={handleGeneratePassword}
                            >
                              {t("Generate random password")}
                            </Button>
                          </div>
                        </AvForm>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewUser);
